import {
    Badge,
    Box,
    Container,
    Flex,
    Grid,
    GridItem,
    Icon,
    Image,
    List,
    Spinner,
    Stack,
    Text,
    useBreakpointValue,
} from "@chakra-ui/react";
import { WarningIcon } from "@phosphor-icons/react/dist/ssr";
import { useEffect, useState } from "react";

import ButtonCompartir from "@/components/fichas/buttonCompartir";
import ButtonRecorridoVirtual from "@/components/fichas/buttonVirtual";
import CardCita from "@/components/fichas/cardCita";
import PhotoGallery from "@/components/fichas/PhotoGallery";
import Map from "@/components/general/Map";
import MarkerFicha from "@/components/general/MarkerFicha";
import { useGetPropertyByIdQuery } from "@/hooks/microservicesApi";
import useFormatter from "@/hooks/useFormatter";
import { default as retailjson } from "@/utilities/retail/retail.json";

const ListItemCharacteristic = ({ children, icon, value }) => {
    return (
        <Stack direction="row" align="center" placeSelf="center" mb={2}>
            <Image boxSize="30px" objectFit="cover" src={icon} alt={children} loading="lazy" />
            <Text
                fontWeight="700"
                fontSize="sm"
                mb={2}
                color="black"
                textAlign="start"
                paddingLeft="10px"
            >
                {children}{" "}
                <Text
                    as="span"
                    fontWeight="400"
                    fontSize="xs"
                    mb={2}
                    color="black"
                    textAlign="start"
                >
                    {value}
                </Text>{" "}
            </Text>
        </Stack>
    );
};

const FichaPropiedad = ({ id, city, savePropsFavorites, session, userFavorites }) => {
    const [urlShare, setUrlShare] = useState(null);
    const [property, setProperty] = useState(null);
    const [marker, setMarker] = useState({});
    const [images, setImages] = useState([]);
    const [amenities, setAmenities] = useState([]);
    const [price, setPrice] = useState(0);
    const [currency, setCurrency] = useState("MXN");
    const [location, setLocation] = useState("");
    const [broker, setBroker] = useState({});
    const [operation, setOperation] = useState("Venta");
    const [antiquity, setAntiquity] = useState("Usado");
    const [serviceRoom, setServiceRoom] = useState("N/D");
    const [_displayContact, setDisplayContact] = useState(true);
    const [offset, setOffset] = useState(0);
    const [isFavorite, setIsFavorite] = useState(false);

    const isGreaterThanMd = useBreakpointValue({ base: false, md: true });

    const { NumberF } = useFormatter();

    const { data } = useGetPropertyByIdQuery(id);

    if (typeof window !== "undefined") {
        window.onscroll = function () {
            // Obtenemos la posicion del scroll en pantall
            var scroll = document.documentElement.scrollTop || document.body.scrollTop;
            let card = document.getElementById("id-card-position");
            if (card) {
                if (scroll > 754) {
                    card.classList.add("space-card-position-propiedad");
                } else {
                    card.classList.remove("space-card-position-propiedad");
                }
            }
        };
    }

    //Validar si el desarrollo es favorito
    useEffect(() => {
        if (data) {
            setIsFavorite(userFavorites?.some((fav) => fav.property_id === data[0]?.property_id));
        }
    }, [data, userFavorites]);

    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
    }, [typeof window === "undefined" ? 0 : window.pageYOffset]);

    const handleScroll = () => {
        setOffset(window.pageYOffset);
        if (offset === 0 || window.pageYOffset < 150 || window.pageYOffset < offset) {
            setDisplayContact(true);
        } else {
            setDisplayContact(false);
        }
    };

    useEffect(() => {
        if (data) {
            if (data.length > 0) {
                if (city === "guiarent") {
                    if (data[0].labels.includes("GUIARENT")) {
                        setProperty(data[0]);
                    } else {
                        setProperty("NO DATA");
                    }
                } else {
                    setProperty(data[0]);
                }
                let data_ = data[0];
                let marker_ = {
                    position: {
                        lat: data_?.location_props
                            ? data_?.location_props.latitude
                            : data_.latitude,
                        lng: data_.location_props
                            ? data_.location_props.longitude
                            : data_.longitude,
                    },
                    title: data_.title,
                };
                setMarker(marker_);
                setImages(data_.photo_props);
                setAmenities(data_.amenities);
                if (data_["sale"]) {
                    setPrice(Intl.NumberFormat().format(data_["sale"]));
                    setCurrency(data_["sale_currency"] ? data_["sale_currency"] : "MXN");
                    setOperation("Venta");
                }
                if (data_["lease"]) {
                    setPrice(Intl.NumberFormat().format(data_["lease"]));
                    setCurrency(data_["lease_currency"] ? data_["lease_currency"] : "MXN");
                    setOperation("Renta");
                }
                if (data_["presale"]) {
                    setPrice(Intl.NumberFormat().format(data_["presale"]));
                    setCurrency(data_["presale_currency"] ? data_["presale_currency"] : "MXN");
                    setOperation("Preventa");
                }

                if (data_.conservation_props.age_year < 0) {
                    setAntiquity("En construcción");
                } else if (
                    data_.conservation_props.age_year === 0 ||
                    data_.conservation_props.age_year === null ||
                    data_.conservation_props.state === "EXCELLENT"
                ) {
                    setAntiquity("Nuevo");
                } else {
                    setAntiquity("Usado");
                }

                let location_ =
                    data_.location_props.street_name +
                    " " +
                    (data_.location_props.external_number || data_.location_props.exterior_number) +
                    " " +
                    data_.location_props.neighborhood +
                    " " +
                    (data_.location_props.postal_code ? data_.location_props.postal_code : "") +
                    " " +
                    data_.location_props.city +
                    " " +
                    data_.location_props.province;

                setLocation(location_.toLocaleLowerCase());

                let broker_ = {
                    name: data_.full_name,
                    image: "https://media.wiggot.mx/" + data_.broker_photo + "-m.jpg",
                    phone: data_.communication_props.phone,
                    email: data_.email,
                };
                setBroker(broker_);

                if (data_.structure_props.service_room !== null) {
                    if (data_.structure_props.service_room == true) setServiceRoom("Si");
                    else setServiceRoom("N/D");
                }
            } else {
                const property_ = retailjson.find((item) => item.code === id);
                if (property_ && city === "retail") {
                    setProperty(property_);
                    let data_ = property_;
                    let marker_ = {
                        position: {
                            lat: data_?.location_props
                                ? data_?.location_props.latitude
                                : data_.latitude,
                            lng: data_.location_props
                                ? data_.location_props.longitude
                                : data_.longitude,
                        },
                        title: data_.title,
                    };
                    setMarker(marker_);
                    setImages(data_.photo_props);
                    setAmenities(data_.amenities);

                    if (data_["sale"]) {
                        //setPrice(Intl.NumberFormat().format(data_["sale"]));
                        setPrice(NumberF(data_["sale"], true, "", 2));
                        setCurrency(data_["sale_currency"] ? data_["sale"] : "MXN");
                        setOperation("Venta");
                    }
                    if (data_["lease"]) {
                        //setPrice(Intl.NumberFormat().format(data_["lease"]));
                        setPrice(NumberF(data_["lease"], true, "", 2));
                        setCurrency(data_["lease_currency"] ? data_["lease_currency"] : "MXN");
                        setOperation("Renta");
                    }
                    if (data_["presale"]) {
                        //setPrice(Intl.NumberFormat().format(data_["presale"]));
                        setPrice(NumberF(data_["presale"], true, "", 2));
                        setCurrency(data_["presale_currency"] ? data_["presale_currency"] : "MXN");
                        setOperation("Preventa");
                    }

                    if (data_?.conservation_props?.age_year < 0) {
                        setAntiquity("En construcción");
                    } else if (
                        data_.conservation_props.age_year === 0 ||
                        data_.conservation_props.age_year === null ||
                        data_.conservation_props.state === "EXCELENT"
                    ) {
                        setAntiquity("Nuevo");
                    } else {
                        setAntiquity("Usado");
                    }

                    let location_ =
                        data_.location_props.street_name +
                        " " +
                        (data_.location_props.external_number ||
                            data_.location_props.exterior_number) +
                        ", " +
                        data_.location_props.neighborhood +
                        ", " +
                        (data_.location_props.postal_code ? data_.location_props.postal_code : "") +
                        ", " +
                        data_.location_props.city +
                        ", " +
                        data_.location_props.province;

                    setLocation(location_.toLocaleLowerCase());

                    let broker_ = {
                        name: data_.full_name,
                        image: "https://media.wiggot.mx/" + data_.broker_photo + "-m.jpg",
                        phone: data_.communication_props.phone,
                        email: data_.email,
                    };
                    setBroker(broker_);

                    if (data_.structure_props.service_room !== null) {
                        if (
                            data_.has_service_room == true ||
                            data_.structure_props.service_room == true
                        )
                            setServiceRoom("Si");
                        else setServiceRoom("N/D");
                    }
                } else {
                    setProperty("NO DATA");
                }
            }
        }
    }, [data]);

    useEffect(() => {
        if (property) {
            setUrlShare(
                city
                    ? city === "guiarent"
                        ? "https://grupoguia.mx/Propiedad/" +
                          city +
                          "/wig-" +
                          id +
                          "?operation=" +
                          (property?.sale_active
                              ? "sale"
                              : property?.presale_active
                                ? "presale"
                                : "lease")
                        : "https://grupoguia.mx/" +
                          city +
                          "/Propiedad/wig-" +
                          id +
                          "?operation=" +
                          (property?.sale_active
                              ? "sale"
                              : property?.presale_active
                                ? "presale"
                                : "lease")
                    : "https://grupoguia.mx/Propiedad/wig-" +
                          id +
                          "?operation=" +
                          (property.sale_active
                              ? "sale"
                              : property?.presale_active
                                ? "presale"
                                : "lease")
            );
        }
    }, [property]);

    const groundSize = property?.structure_props?.ground_size;
    const min_size = property?.structure_props?.min_ground_size;

    const renderGroundSize = () => {
        if (groundSize && groundSize > 0) {
            return groundSize.toLocaleString("en-US");
        } else if (min_size && min_size > 0) {
            return `${min_size.toLocaleString("en-US")}`;
        }
        return "";
    };

    return (
        <Box
            bg="transparent"
            color="gray.600"
            _dark={{ bg: "whiteAlpha.100", color: "gray.200" }}
            w="full"
            mx="auto"
            maxW="3x1"
            px={{ base: "6", md: "8" }}
        >
            <Container maxW="7xl" py={10} asChild mx="auto">
                <Stack>
                    {property ? (
                        <>
                            {property === "NO DATA" ? (
                                <Stack my={20} alignItems="center">
                                    <Icon boxSize="50px" color="brand.500">
                                        <WarningIcon weight="fill" />
                                    </Icon>
                                    <Text fontWeight="700" fontSize="2xl">
                                        Lo sentimos, esta propiedad no esta disponible.
                                    </Text>
                                </Stack>
                            ) : (
                                <>
                                    <Grid templateColumns="repeat(7, 1fr)" gap={6}>
                                        <GridItem colSpan={5}>
                                            <Text
                                                fontWeight="700"
                                                fontSize="2xl"
                                                mb={2}
                                                color="black"
                                            >
                                                {property.title}
                                            </Text>
                                        </GridItem>
                                        {city != "retail" && (
                                            <GridItem colSpan={2}>
                                                <Text
                                                    fontWeight="400"
                                                    fontSize="sm"
                                                    mb={2}
                                                    color="black"
                                                    textAlign="end"
                                                >
                                                    Código: {id}
                                                </Text>
                                            </GridItem>
                                        )}
                                    </Grid>
                                    <Grid templateColumns="repeat(7, 1fr)" gap={2}>
                                        <GridItem colSpan={5}>
                                            {price ? (
                                                <Text
                                                    fontWeight="400"
                                                    fontSize="lg"
                                                    mb={2}
                                                    color="black"
                                                >
                                                    {city !== "retail"
                                                        ? "Total de " + operation.toLowerCase()
                                                        : "Desde"}
                                                    : {price} {currency}{" "}
                                                    {/* &middot; Total de apartado: $50,000 MXN */}
                                                    {city === "retail" &&
                                                    (property.max_sale || property.max_lease)
                                                        ? " - Hasta " +
                                                          NumberF(
                                                              property.max_sale ||
                                                                  property.max_lease,
                                                              true,
                                                              "",
                                                              2
                                                          ) +
                                                          " " +
                                                          currency
                                                        : ""}
                                                </Text>
                                            ) : null}
                                        </GridItem>
                                        <GridItem colSpan={2}>
                                            <Grid templateColumns="repeat(3, 1fr)" gap={2}>
                                                <GridItem
                                                    colSpan={2}
                                                    placeSelf="end"
                                                    borderRadius="md"
                                                    cursor="pointer"
                                                    _hover={{ bg: "gray.100" }}
                                                    _active={{ bg: "gray.200" }}
                                                >
                                                    <ButtonCompartir
                                                        icon="https://media.grupoguia.mx/assets/home-page/fichas/compartir.webp"
                                                        url={urlShare}
                                                        fontsize="sm"
                                                    >
                                                        Compartir
                                                    </ButtonCompartir>
                                                </GridItem>
                                                {session && (
                                                    <GridItem colSpan={1} placeSelf="end">
                                                        <Flex
                                                            gap={3}
                                                            align="center"
                                                            cursor="pointer"
                                                            _hover={{ bg: "gray.100" }}
                                                            _active={{ bg: "gray.200" }}
                                                            p={2}
                                                            borderRadius="md"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                savePropsFavorites(
                                                                    data[0]?.property_id,
                                                                    null
                                                                ); /// property_id, development_id
                                                            }}
                                                        >
                                                            <Image
                                                                src={
                                                                    isFavorite
                                                                        ? "https://media.grupoguia.mx/assets/apps-icons/favorite_active.svg"
                                                                        : "https://media.grupoguia.mx/assets/apps-icons/favorite.svg"
                                                                }
                                                                alt="favorite"
                                                                maxH="3vh"
                                                            />

                                                            <Text
                                                                fontWeight="400"
                                                                fontSize="sm"
                                                                color="black"
                                                                textAlign="end"
                                                            >
                                                                Favorito
                                                            </Text>
                                                        </Flex>
                                                    </GridItem>
                                                )}
                                            </Grid>
                                        </GridItem>
                                        {property?.legal_status ? (
                                            <GridItem colSpan={5}>
                                                <Text
                                                    fontWeight="300"
                                                    fontSize="lg"
                                                    mb={2}
                                                    color="gray.700"
                                                >
                                                    {property.legal_status}
                                                </Text>
                                            </GridItem>
                                        ) : null}
                                    </Grid>

                                    <Grid templateColumns="repeat(7, 1fr)" gap={6}>
                                        <GridItem colSpan={5}>
                                            <Grid templateColumns="repeat(7, 1fr)" gap={2}>
                                                <GridItem colSpan={1} placeSelf="start">
                                                    <Badge
                                                        paddingLeft="5"
                                                        paddingRight="5"
                                                        paddingTop="1"
                                                        paddingBottom="1"
                                                        borderRadius="full"
                                                        mx={1}
                                                        my={1}
                                                        color="white"
                                                        bg="#414141"
                                                        fontWeight="400"
                                                    >
                                                        {operation}
                                                    </Badge>
                                                </GridItem>
                                                <GridItem colSpan={1} placeSelf="start">
                                                    <Badge
                                                        paddingLeft="5"
                                                        paddingRight="5"
                                                        paddingTop="1"
                                                        paddingBottom="1"
                                                        borderRadius="full"
                                                        mx={1}
                                                        my={1}
                                                        color="white"
                                                        bg="#414141"
                                                        fontWeight="400"
                                                    >
                                                        {antiquity}
                                                    </Badge>
                                                </GridItem>
                                                {property.antiquity_years ? (
                                                    <GridItem colSpan={2} placeSelf="start">
                                                        <Badge
                                                            paddingLeft="5"
                                                            paddingRight="5"
                                                            paddingTop="1"
                                                            paddingBottom="1"
                                                            borderRadius="full"
                                                            mx={1}
                                                            my={1}
                                                            color="white"
                                                            bg="#414141"
                                                            fontWeight="400"
                                                        >
                                                            {property.conservation_props.age_year}{" "}
                                                            años de antigüedad
                                                        </Badge>
                                                    </GridItem>
                                                ) : null}
                                            </Grid>
                                        </GridItem>
                                    </Grid>

                                    <Box mt="14" pl={0} className="FichaPropiedad">
                                        <PhotoGallery imageUrls={images} pl={0} mt={4} />
                                    </Box>

                                    {property.matterport_url ? (
                                        <Box
                                            textAlign="center"
                                            w="50%"
                                            position="relative"
                                            top="-7"
                                        >
                                            <ButtonRecorridoVirtual url={property.matterport_url} />
                                        </Box>
                                    ) : null}

                                    <Grid templateColumns="repeat(5, 1fr)" gap={9}>
                                        <GridItem colSpan={isGreaterThanMd ? 3 : 5}>
                                            <GridItem
                                                rowSpan={1}
                                                colSpan={3}
                                                marginTop="8"
                                                paddingBottom="8"
                                                borderBottomWidth={1}
                                                borderStyle="solid"
                                                borderColor="gray.200"
                                            >
                                                <Grid templateColumns="repeat(4, 1fr)" gap={2}>
                                                    <GridItem
                                                        colSpan={1}
                                                        display="flex"
                                                        textAlign="center"
                                                        justifySelf="center"
                                                        alignItems="center"
                                                    >
                                                        <Image
                                                            src="https://media.grupoguia.mx/assets/home-page/fichas/icons/bed.svg"
                                                            alt="simple icon"
                                                            w={10}
                                                            mr={4}
                                                        />

                                                        <Text fontSize="md" fontWeight="400">
                                                            {property.structure_props.bedrooms
                                                                ? property.structure_props.bedrooms
                                                                : ""}
                                                        </Text>
                                                    </GridItem>
                                                    <GridItem
                                                        colSpan={1}
                                                        display="flex"
                                                        textAlign="center"
                                                        justifySelf="center"
                                                        alignItems="center"
                                                    >
                                                        <Image
                                                            src="https://media.grupoguia.mx/assets/home-page/fichas/icons/headband.svg"
                                                            alt="simple icon"
                                                            w={10}
                                                            mr={4}
                                                        />

                                                        <Text fontSize="md" fontWeight="400">
                                                            {renderGroundSize()} mt&sup2;
                                                        </Text>
                                                    </GridItem>

                                                    <GridItem
                                                        colSpan={1}
                                                        display="flex"
                                                        textAlign="center"
                                                        justifySelf="center"
                                                        alignItems="center"
                                                    >
                                                        <Image
                                                            src="https://media.grupoguia.mx/assets/home-page/fichas/icons/bath.svg"
                                                            alt="simple icon"
                                                            w={10}
                                                            mr={4}
                                                        />

                                                        <Text fontSize="md" fontWeight="400">
                                                            {property.structure_props.bathrooms
                                                                ? property.structure_props.bathrooms
                                                                : ""}
                                                        </Text>
                                                    </GridItem>
                                                    <GridItem
                                                        colSpan={1}
                                                        display="flex"
                                                        textAlign="center"
                                                        justifySelf="center"
                                                        alignItems="center"
                                                    >
                                                        <Image
                                                            src="https://media.grupoguia.mx/assets/home-page/fichas/icons/parking-lot.svg"
                                                            alt="simple icon"
                                                            w={10}
                                                            mr={4}
                                                        />

                                                        <Text fontSize="md" fontWeight="400">
                                                            {property.structure_props.parking_lots
                                                                ? property.structure_props
                                                                      .parking_lots
                                                                : ""}
                                                        </Text>
                                                    </GridItem>
                                                </Grid>
                                            </GridItem>
                                            <GridItem
                                                rowSpan={1}
                                                colSpan={3}
                                                marginTop="8"
                                                paddingBottom="8"
                                                borderBottomWidth={1}
                                                borderStyle="solid"
                                                borderColor="gray.200"
                                            >
                                                <Text
                                                    fontWeight="700"
                                                    fontSize="lg"
                                                    mb={6}
                                                    color="black"
                                                >
                                                    {" "}
                                                    Descripción:{" "}
                                                </Text>
                                                <Text
                                                    fontWeight="400"
                                                    fontSize="md"
                                                    mb={0}
                                                    color="black"
                                                    textAlign="justify"
                                                    marginTop="20px"
                                                >
                                                    {property.description}
                                                </Text>
                                            </GridItem>
                                            {property.structure_props.ground_size ||
                                            property.structure_props.construction_size ||
                                            property.structure_props.floors ||
                                            property.structure_props.bedrooms ||
                                            property.structure_props.bathrooms ||
                                            property.structure_props.parking_lots ||
                                            property.structure_props.service_room ? (
                                                <GridItem
                                                    rowSpan={1}
                                                    colSpan={3}
                                                    marginTop="8"
                                                    paddingBottom="8"
                                                    borderBottomWidth={1}
                                                    borderStyle="solid"
                                                    borderColor="gray.200"
                                                >
                                                    <Text
                                                        fontWeight="700"
                                                        fontSize="lg"
                                                        mb={6}
                                                        color="black"
                                                    >
                                                        {" "}
                                                        Características:{" "}
                                                    </Text>
                                                    <Grid
                                                        templateColumns={{
                                                            base: "repeat(1, 1fr)",
                                                            md: "repeat(3, 1fr)",
                                                        }}
                                                        gap={2}
                                                    >
                                                        {property.structure_props.ground_size ? (
                                                            <GridItem colSpan={1} placeSelf="start">
                                                                <ListItemCharacteristic
                                                                    icon="https://media.grupoguia.mx/assets/home-page/fichas/Caracteristicas/cinta-metrica.webp"
                                                                    value={
                                                                        property.structure_props
                                                                            .ground_size + " m²"
                                                                    }
                                                                >
                                                                    Metros del terreno:
                                                                </ListItemCharacteristic>
                                                            </GridItem>
                                                        ) : null}
                                                        {property.structure_props
                                                            .construction_size ? (
                                                            <GridItem colSpan={1} placeSelf="start">
                                                                <ListItemCharacteristic
                                                                    icon="https://media.grupoguia.mx/assets/home-page/fichas/Caracteristicas/pared-de-ladrillo.webp"
                                                                    value={
                                                                        property.structure_props
                                                                            .construction_size +
                                                                        " m²"
                                                                    }
                                                                >
                                                                    Metros de construcción:
                                                                </ListItemCharacteristic>
                                                            </GridItem>
                                                        ) : null}
                                                        {property.structure_props.floors ? (
                                                            <GridItem colSpan={1} placeSelf="start">
                                                                <ListItemCharacteristic
                                                                    icon="https://media.grupoguia.mx/assets/home-page/fichas/Caracteristicas/escalera.webp"
                                                                    value={
                                                                        property.structure_props
                                                                            .floors
                                                                    }
                                                                >
                                                                    Niveles:
                                                                </ListItemCharacteristic>
                                                            </GridItem>
                                                        ) : null}

                                                        {property.structure_props.bedrooms ? (
                                                            <GridItem colSpan={1} placeSelf="start">
                                                                <ListItemCharacteristic
                                                                    icon="https://media.grupoguia.mx/assets/home-page/fichas/Caracteristicas/bed.webp"
                                                                    value={
                                                                        property.structure_props
                                                                            .bedrooms
                                                                    }
                                                                >
                                                                    Número de cuartos:
                                                                </ListItemCharacteristic>
                                                            </GridItem>
                                                        ) : null}
                                                        {property.structure_props.bathrooms ? (
                                                            <GridItem colSpan={1} placeSelf="start">
                                                                <ListItemCharacteristic
                                                                    icon="https://media.grupoguia.mx/assets/home-page/fichas/Caracteristicas/banera.webp"
                                                                    value={
                                                                        property.structure_props
                                                                            .bathrooms
                                                                    }
                                                                >
                                                                    Número de baños:
                                                                </ListItemCharacteristic>
                                                            </GridItem>
                                                        ) : null}
                                                        {property.structure_props.half_bathrooms ? (
                                                            <GridItem colSpan={1} placeSelf="start">
                                                                <ListItemCharacteristic
                                                                    icon="https://media.grupoguia.mx/assets/home-page/fichas/Caracteristicas/bano.webp"
                                                                    value={
                                                                        property.structure_props
                                                                            .half_bathrooms
                                                                    }
                                                                >
                                                                    Número de medios baños:
                                                                </ListItemCharacteristic>
                                                            </GridItem>
                                                        ) : null}
                                                        {property.structure_props.parking_lots ? (
                                                            <GridItem colSpan={1} placeSelf="start">
                                                                <ListItemCharacteristic
                                                                    icon="https://media.grupoguia.mx/assets/home-page/fichas/Caracteristicas/estacionamiento.webp"
                                                                    value={
                                                                        property.structure_props
                                                                            .parking_lots
                                                                    }
                                                                >
                                                                    Estacionamientos:
                                                                </ListItemCharacteristic>
                                                            </GridItem>
                                                        ) : null}
                                                        {property.structure_props.service_room ? (
                                                            <GridItem colSpan={1} placeSelf="start">
                                                                <ListItemCharacteristic
                                                                    icon="https://media.grupoguia.mx/assets/home-page/fichas/Caracteristicas/lavadora.webp"
                                                                    value={serviceRoom}
                                                                >
                                                                    Cuarto de servicio:
                                                                </ListItemCharacteristic>
                                                            </GridItem>
                                                        ) : null}
                                                    </Grid>
                                                </GridItem>
                                            ) : null}
                                            {amenities?.length > 0 ? (
                                                <GridItem
                                                    rowSpan={1}
                                                    colSpan={3}
                                                    marginTop="8"
                                                    paddingBottom="8"
                                                    borderBottomWidth={1}
                                                    borderStyle="solid"
                                                    borderColor="gray.200"
                                                    _dark={{ borderColor: "gray.700" }}
                                                >
                                                    <Text
                                                        fontWeight="700"
                                                        fontSize="lg"
                                                        mb={6}
                                                        color="black"
                                                    >
                                                        {" "}
                                                        Amenidades:{" "}
                                                    </Text>
                                                    <Grid templateColumns="repeat(3, 1fr)" gap={2}>
                                                        {amenities.map((amenity, idx) => (
                                                            <GridItem
                                                                colSpan={1}
                                                                placeSelf="start"
                                                                key={idx}
                                                            >
                                                                <List.Root ml={4}>
                                                                    <List.Item fontSize="sm">
                                                                        {amenity.replaceAll(
                                                                            "-",
                                                                            " "
                                                                        )}
                                                                    </List.Item>
                                                                </List.Root>
                                                            </GridItem>
                                                        ))}
                                                    </Grid>
                                                </GridItem>
                                            ) : null}
                                            <GridItem rowSpan={1} marginTop="8">
                                                <Stack
                                                    direction="row"
                                                    align="center"
                                                    placeSelf="center"
                                                    mb={2}
                                                >
                                                    <Image
                                                        boxSize="30px"
                                                        objectFit="cover"
                                                        src="https://media.grupoguia.mx/assets/home-page/fichas/Ubicacion/ubicacion.webp"
                                                        alt="ubicación"
                                                        loading="lazy"
                                                    />

                                                    <Stack gap={0}>
                                                        <Text
                                                            fontWeight="700"
                                                            fontSize="lg"
                                                            color="black"
                                                            textAlign="start"
                                                        >
                                                            Ubicación:
                                                        </Text>
                                                        <Text
                                                            as="span"
                                                            fontWeight="400"
                                                            fontSize="sm"
                                                            mb={2}
                                                            color="black"
                                                            textAlign="start"
                                                            textTransform="capitalize"
                                                        >
                                                            {location}
                                                        </Text>
                                                    </Stack>
                                                </Stack>
                                                <Stack
                                                    direction="row"
                                                    align="center"
                                                    h="400px"
                                                    placeSelf="center"
                                                    mb={2}
                                                    width="100%"
                                                >
                                                    <Map zoom={14} center={marker.position}>
                                                        <MarkerFicha marker={marker} />
                                                    </Map>
                                                </Stack>
                                            </GridItem>
                                        </GridItem>
                                        {isGreaterThanMd ? (
                                            <GridItem colSpan={2}>
                                                <div
                                                    id="id-card-position"
                                                    className="card-position"
                                                >
                                                    <GridItem
                                                        rowSpan={1}
                                                        marginTop="8"
                                                        paddingBottom="0"
                                                    >
                                                        <CardCita
                                                            test="test"
                                                            urlBrochure="none"
                                                            numeroAsesor={broker.phone}
                                                            nameAsesor={broker.name}
                                                            tipo="Propiedad"
                                                            city={city}
                                                            id={id}
                                                            urlDev={
                                                                "https://grupoguia.mx/Propiedad/" +
                                                                (city ? city + "/" : "") +
                                                                "wig-" +
                                                                id
                                                            }
                                                            hubspotForm={
                                                                city === "retail"
                                                                    ? property.external_props
                                                                          .hubspot.hbs_contact
                                                                    : "03479824-13fb-4023-a9c1-a35a76088498"
                                                            }
                                                            minPrice={
                                                                NumberF(
                                                                    property.sale
                                                                        ? property.sale
                                                                        : property.presale
                                                                          ? property.presale
                                                                          : property.lease,
                                                                    true,
                                                                    "",
                                                                    2
                                                                ) +
                                                                " " +
                                                                currency
                                                            }
                                                        />
                                                    </GridItem>
                                                </div>
                                            </GridItem>
                                        ) : null}
                                    </Grid>
                                </>
                            )}
                        </>
                    ) : (
                        <Stack my={20} alignItems="center">
                            <Spinner />
                            <Text>Cargando...</Text>
                        </Stack>
                    )}
                </Stack>
            </Container>
        </Box>
    );
};

export default FichaPropiedad;
